function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_d)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16.3389 20.297L14.4258 18.4023C14.2393 18.2175 13.936 18.2175 13.7495 18.4023C13.563 18.587 13.563 18.8873 13.7495 19.0721L15.324 20.6314L13.7485 22.1918C13.562 22.3765 13.562 22.6768 13.7485 22.8616C13.8423 22.9534 13.9647 22.9999 14.0872 22.9999C14.2096 22.9999 14.332 22.9535 14.4258 22.8616L16.3389 20.9668C16.5255 20.7821 16.5255 20.4817 16.3389 20.297Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.8242 13.8056C23.5783 13.709 23.3019 13.8331 23.2063 14.0766C23.1116 14.3201 23.234 14.5948 23.4808 14.6886C25.1099 15.311 26.0444 16.0963 26.0444 16.8419C26.0444 18.0223 23.5191 19.5353 18.8396 20.0166C18.5775 20.0431 18.3871 20.2761 18.4139 20.5367C18.4388 20.7802 18.6463 20.9611 18.8883 20.9611C18.9046 20.9611 18.9218 20.9601 18.9371 20.9592C23.8347 20.4561 27 18.8409 27 16.8429C26.9999 15.6502 25.9018 14.5996 23.8242 13.8056Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.0005 20.1578C10.0822 20.1578 5.95655 18.41 5.95655 16.842C5.95655 16.0965 6.89113 15.3111 8.51918 14.6877C8.76597 14.5939 8.88843 14.3202 8.79373 14.0758C8.69903 13.8323 8.42067 13.711 8.1758 13.8048C6.09815 14.5987 5 15.6493 5 16.8421C5 19.6112 10.6676 21.1052 16.0005 21.1052C16.2645 21.1052 16.4788 20.893 16.4788 20.6315C16.4788 20.3701 16.2645 20.1578 16.0005 20.1578Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.0003 8.78944C14.1542 8.78944 12.6523 10.2768 12.6523 12.1052C12.6523 13.9337 14.1541 15.421 16.0003 15.421C17.8465 15.421 19.3483 13.9336 19.3483 12.1052C19.3483 10.2768 17.8465 8.78944 16.0003 8.78944ZM16.0003 14.4736C14.6812 14.4736 13.6089 13.4107 13.6089 12.1052C13.6089 10.7998 14.6813 9.73684 16.0003 9.73684C17.3194 9.73684 18.3917 10.7998 18.3917 12.1052C18.3917 13.4107 17.3194 14.4736 16.0003 14.4736Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.7398 6.89475H18.6874L18.1278 5.78633C17.8839 5.30126 17.3912 5 16.8441 5H15.1567C14.6095 5 14.1169 5.30126 13.873 5.78535L13.3134 6.8947H10.261C8.94195 6.89475 7.86963 7.95769 7.86963 9.26315V14.9473C7.86963 16.2528 8.94195 17.3157 10.261 17.3157H21.7398C23.0589 17.3157 24.1312 16.2528 24.1312 14.9473V9.26315C24.1312 7.95769 23.0589 6.89475 21.7398 6.89475ZM23.1746 14.9473C23.1746 15.7308 22.5309 16.3684 21.7398 16.3684H10.261C9.46993 16.3684 8.82618 15.7308 8.82618 14.9473V9.26315C8.82618 8.47966 9.46993 7.8421 10.261 7.8421H13.609C13.7898 7.8421 13.9553 7.74072 14.0366 7.58063L14.7291 6.20882C14.8104 6.04682 14.974 5.94735 15.1567 5.94735H16.8441C17.0268 5.94735 17.1904 6.04682 17.2717 6.20976L17.9642 7.58058C18.0455 7.74067 18.211 7.84205 18.3918 7.84205H21.7398C22.5309 7.84205 23.1746 8.47962 23.1746 9.2631V14.9473Z",
  fill: "white"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_d",
  x: 0,
  y: 0,
  width: 32,
  height: 28,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2.5
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})));

function SvgSwitchCamera(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 28,
    viewBox: "0 0 32 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchCamera);
export default __webpack_public_path__ + "static/media/switch-camera.0957292a.svg";
export { ForwardRef as ReactComponent };